import React from "react";
import { connect } from "react-redux";
import Header from "../../common/components/Header";
import {Grid} from "semantic-ui-react";
import {unmountTxDebugLogsPage,} from "../actions/supportActions";
import Breadcrumb from '../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../veritas/breadcrumb/BreadcrumbActions';
import Sidebar from "../../common/components/Sidebar";
import SupportSidebarButtons from "./SupportSidebarButtons";

export class SupportHomePage extends React.Component {

    componentDidMount() {
        document.title = `Marvel - Support`;

        this.props.setBreadCrumb({
            parent: { url: '/support', text: 'Support' },
            list: { url: '', text: '' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentWillUnmount() {
        this.props.unmountSupportPage();
    }

    pageContent(){
        return (
            <div className="support-container">
                <p>WELCOME TO SUPPORT</p>
            </div>
        );
    }

    render() {
        return(
            <div className="support">
                <Header/>
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <SupportSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.pageContent()}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = dispatch => ({
    unmountSupportPage: () => {dispatch(unmountTxDebugLogsPage())},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SupportHomePage)
